import { getMaintenanceMessage } from './Maintenance.service'

const defaultState = {
  header: '',
  subHeader: '',
  footerImageUrl: ''
}

const getters = {
  header: (state) => state.header,
  subHeader: (state) => state.subHeader,
  footerImageUrl: (state) => state.footerImageUrl
}

const mutations = {
  setMaintenanceMessage: (state, message) => {
    state.header = message.header
    state.subHeader = message.subHeader
    state.footerImageUrl = message.footerImageUrl
  }
}

const actions = {
  getMaintenanceMessage: async ({ commit }) => {
    const message = await getMaintenanceMessage()

    commit('setMaintenanceMessage', message)
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
